import { isString, sanitizeBindable, sanitizeString } from './helpers';
const ICON_SIZES = ['sm', 'md', 'lg', 'xl'];
const ICON_STYLES = ['solid', 'regular', 'brands'];
function sanitizeIconSize(value) {
  if (isString(value) && ICON_SIZES.includes(value)) {
    return value;
  }
  return undefined;
}
function sanitizeIconStyle(value) {
  if (isString(value) && ICON_STYLES.includes(value)) {
    return value;
  }
  return undefined;
}
function sanitizeIconName(value) {
  if (!isString(value)) return undefined;
  // Trim first so leading/trailing whitespace never produces an empty first token.
  // FA icon names never contain spaces — take only the first word so that a
  // name like "circle-check injected-class" cannot inject extra CSS classes.
  const firstName = value.trim().split(/\s/)[0];
  return firstName || undefined;
}
export function sanitizeIcon(el) {
  const name = sanitizeBindable(el.name, sanitizeIconName);
  if (name === undefined) {
    return null;
  }
  return {
    type: 'Icon',
    name,
    style: sanitizeBindable(el.style, sanitizeIconStyle),
    size: sanitizeBindable(el.size, sanitizeIconSize),
    color: sanitizeBindable(el.color, sanitizeString),
    ariaLabel: sanitizeBindable(el.ariaLabel, sanitizeString)
  };
}